import { ExternalIssuesFormComponent } from './app/issues/external-issues-form/external-issues-form.component';
import { ExternalIssuesDetailsComponent } from './app/issues/external-issues-details/external-issues-details.component';
import { ExternalIssuesGridComponent } from './app/issues/external-issues-grid/external-issues-grid.component';
import { ClientFromComponent } from './app/client/client-from/client-from.component';
import { ClientGridComponent } from './app/client/client-grid/client-grid.component';
import { MastersComponent } from './app/masters/masters.component';
import { ProjectFormComponent } from './app/masters/project/project-form/project-form.component';
import { ProjectGridComponent } from './app/masters/project/project-grid/project-grid.component';
import { CompanyFormComponent } from './app/masters/company/company-form/company-form.component';
import { CompanyGridComponent } from './app/masters/company/company-grid/company-grid.component';
import { IssuesGridComponent } from './app/issues/issues-grid/issues-grid.component';
import { IssuesComponent } from './app/issues/issues.component';
import { Routes } from '@angular/router'
import { AppComponent } from './app/khb.component';
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesComponent } from './app/ultilities/roles/roles.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserComponent } from './app/ultilities/user/user.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimsComponent } from './app/ultilities/claims/claims/claims.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { SettingComponent } from './app/ultilities/setting/setting.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
// import { IssueDetailsComponent } from './app/Issues/issue-details/issue-details.component';
import { IssueAlertGridComponent } from './app/issues/issue-alert-grid/issue-alert-grid.component';
import { IssueAlertUpdateComponent } from './app/issues/issue-alert-update/issue-alert-update.component';
import { IssueDetailedViewComponent } from './app/issues/issue-detailed-view/issue-detailed-view.component';
import { ProspectComponent } from './app/prospect/prospect.component';
import { TelecallerGridComponent } from './app/prospect/telecaller/telecaller-grid/telecaller-grid.component';
import { TelecallerFormComponent } from './app/prospect/telecaller/telecaller-form/telecaller-form.component';
import { UnifyMarketingGridComponent } from './app/prospect/unify-marketing/unify-marketing-grid/unify-marketing-grid.component';
import { UnifyMarketingFormComponent } from './app/prospect/unify-marketing/unify-marketing-form/unify-marketing-form.component';
import { UnifyMarketingNoteComponent } from './app/prospect/unify-marketing/unify-marketing-note/unify-marketing-note.component';
import { ReportsComponent } from './app/reports/reports.component';
import { TodaysTicketsComponent } from './app/reports/todays-tickets/todays-tickets.component';
import { AllClosedTicketsComponent } from './app/reports/all-closed-tickets/all-closed-tickets.component';
import { AllOpenedTicketsComponent } from './app/reports/all-opened-tickets/all-opened-tickets.component';
import { AllUnassignedTicketsComponent } from './app/reports/all-unassigned-tickets/all-unassigned-tickets.component';
import { ClientHighestTicketsComponent } from './app/reports/client-highest-tickets/client-highest-tickets.component';
import { ClientLowestTicketsComponent } from './app/reports/client-lowest-tickets/client-lowest-tickets.component';
import { ClientOpenNclosedTicketCountComponent } from './app/reports/client-open-nclosed-ticket-count/client-open-nclosed-ticket-count.component';
import { ClientsCountForProjectsComponent } from './app/reports/clients-count-for-projects/clients-count-for-projects.component';
import { ExpectedDatewiseAllTicketCountComponent } from './app/reports/expected-datewise-all-ticket-count/expected-datewise-all-ticket-count.component';
import { OverdueReportsComponent } from './app/reports/overdue-reports/overdue-reports.component';
import { PriorityIssueComponent } from './app/reports/priority-issue/priority-issue.component';
import { ProjectwiseClientListComponent } from './app/reports/projectwise-client-list/projectwise-client-list.component';
import { TodaysClosedTicketsComponent } from './app/reports/todays-closed-tickets/todays-closed-tickets.component';
import { TodaysOpenUnresolvedTicketsComponent } from './app/reports/todays-open-unresolved-tickets/todays-open-unresolved-tickets.component';
import { TodaysOpenedTicketsComponent } from './app/reports/todays-opened-tickets/todays-opened-tickets.component';
import { TodaysUnassignedTicketsComponent } from './app/reports/todays-unassigned-tickets/todays-unassigned-tickets.component';
import { TelecallerDetailsGridComponent } from './app/prospect/telecaller-details/telecaller-details-grid/telecaller-details-grid.component';
import { UnifyMarketingDetailsGridComponent } from './app/prospect/unify-marketing-details/unify-marketing-details-grid/unify-marketing-details-grid.component';
import { UnifyMarketingDetailsFormComponent } from './app/prospect/unify-marketing-details/unify-marketing-details-form/unify-marketing-details-form.component';
import { TelecallerViewComponent } from './app/prospect/telecaller/telecaller-view/telecaller-view.component';
import { ClientsGridComponent } from './app/masters/clients/clients-grid/clients-grid.component';
import { ClientsFormComponent } from './app/masters/clients/clients-form/clients-form.component';
import { InternalUsersGridComponent } from './app/masters/internal-users/internal-users-grid/internal-users-grid.component';
import { InternalUsersFormComponent } from './app/masters/internal-users/internal-users-form/internal-users-form.component';
import { EmployeewiseClosedTicketsComponent } from './app/reports/employeewise-closed-tickets/employeewise-closed-tickets.component';
import { EmployeewisePendingTicketsComponent } from './app/reports/employeewise-pending-tickets/employeewise-pending-tickets.component';
import { OverallreportComponent } from './app/reports/overallreport/overallreport.component';

// var data = localStorage.getItem("accessToken");
// var defaultPage;
// if(data) defaultPage = "/home"; else defaultPage = "/login";
//canActivate : [AuthGuard],
export const appRoutes: Routes = [
    {
        path: 'home',component: HomepageComponent, canActivate : [AuthGuard],
        children: [
            {
                path: 'password',component: UltilitiesComponent,
                children: [{path: '', component: ChangePasswordComponent}]
            },  

            {
                path: 'password/:userId',component: UltilitiesComponent,
                children: [{path: '', component: ChangePasswordComponent}]
            },  

            {
                path: 'rolesgrid',component: UltilitiesComponent,
                children: [{path: '', component: RolesGridComponent}]
            },  
                
            {
                path: 'rolesform',component: UltilitiesComponent,
                children: [{path: '', component: RolesFormComponent}]
            },
        
            {
                path: 'rolesform/:roleId/:mode',component: UltilitiesComponent,
                children: [{path: '', component: RolesFormComponent}]
            },            
                                          
            {
                path: 'userlist',component: UltilitiesComponent,
                children: [{path: '', component: UserGridComponent}]
            }, 
                    
            {
                path: 'userform',component: UltilitiesComponent,
                children: [{path: '', component: UserFormComponent}]
            },   

            {
                path: 'userform/:Id/:mode',component: UltilitiesComponent,
                children: [{path: '', component: UserFormComponent}]
            },    
                        
            {
                path: 'claimslist',component: UltilitiesComponent,
                children: [{path: '', component: ClaimGridComponent}]
            },  
        
            {
                path: 'claimform',component: UltilitiesComponent,
                children: [{path: '', component: ClaimFormComponent}]
            },     
                           
            // {
            //     path: 'claimform/:roleId/:roleName/:officeName',component: UltilitiesComponent,
            //     children: [{path: '', component: ClaimFormComponent}]
            // },
            
            {
                path: 'claimform/:roleId',component: UltilitiesComponent,
                children: [{path: '', component: ClaimFormComponent}]
            },
            {
                path: 'issue',component: IssuesComponent,
                children: [
                    {path: '', component:IssuesGridComponent},
                    {path: 'issue-details/:IS_Id/:IS_Ticket_No/:mode', component:IssueDetailedViewComponent}
                    // {path:'issue-form',component:IssuesFormComponent}
                ]
            },
            {
                path: 'issue-external',component: IssuesComponent,
                children: [
                    {path: '', component:ExternalIssuesGridComponent},
                    {path: 'eissue-details/:IS_Id/:IS_Ticket_No/:mode', component:ExternalIssuesDetailsComponent},
                    {path:'eissue-form',component:ExternalIssuesFormComponent}
                ]
            },
            {
                path: 'issue-alert',component: IssuesComponent,
                children: [
                    {path: '', component:IssueAlertGridComponent},
                    {path: 'issue-update/:IS_Id/:IS_Ticket_No', component:IssueAlertUpdateComponent},
                    {path: 'issue-update/:IS_Id/:IS_Ticket_No/:mode', component:IssueAlertUpdateComponent}
                ]
            },
            {
                path: 'telecaller',component: ProspectComponent,
                children: [
                    {path: '', component:TelecallerGridComponent},
                    {path: 'telecaller-form', component:TelecallerFormComponent},
                    // {path: 'telecaller-note/:Pros_Id/:mode', component:UnifyMarketingNoteComponent}
                    {path: 'telecaller-view/:Pros_Id', component:TelecallerViewComponent},
                ]
            },

            {
                path: 'telecaller-alert',component: ProspectComponent,
                children: [
                    {path: '', component:TelecallerDetailsGridComponent},
                    {path: 'telecaller-alert-note/:Pros_Id/:PR_Id/:mode', component:UnifyMarketingNoteComponent}
                    // {path: 'telecaller-note/:Pros_Id/:mode', component:UnifyMarketingNoteComponent}
                ]
            },

            {
                path: 'marketing-alert',component: ProspectComponent,
                children: [
                    {path: '', component:UnifyMarketingDetailsGridComponent},
                     {path: 'marketing-alert-from/:Pros_Id/:PR_Id', component:UnifyMarketingDetailsFormComponent},
                     {path: 'marketing-alert-from/:Pros_Id/:PR_Id/:mode', component:UnifyMarketingNoteComponent}
                    // {path: 'telecaller-note/:Pros_Id/:mode', component:UnifyMarketingNoteComponent}
                ]
            },

            {
                path: 'prospect',component: ProspectComponent,
                children: [
                    {path: '', component:UnifyMarketingGridComponent},
                    {path: 'prospect-form', component:UnifyMarketingFormComponent},
                    {path: 'prospect-form/:Pros_Id', component:UnifyMarketingFormComponent},
                    {path: 'prospect-note/:Pros_Id/:mode', component:UnifyMarketingNoteComponent}

                ]
            },

            {
                path: 'masters',component: MastersComponent,
                children: [
                    {path: '', component:CompanyGridComponent},
                    {path: 'company-form', component:CompanyFormComponent}]
            },
            {
                path: 'projects',component: MastersComponent,
                children: [
                    {path: '', component:ProjectGridComponent},
                    {path: 'project-form', component:ProjectFormComponent},
                    {path: 'project-form/:Tr_Pro_Id/:mode', component:ProjectFormComponent},
                ]
            },
            {
                path: 'clients',component: MastersComponent,
                children: [
                    {path: '', component:ClientsGridComponent},
                    {path: 'client-form', component:ClientsFormComponent},
                    {path: 'client-form/:C_Id/:mode', component:ClientsFormComponent},
                ]
            },
            {
                path: 'internal-users',component: MastersComponent,
                children: [
                    {path: '', component:InternalUsersGridComponent},
                    {path: 'internal-users-form', component:InternalUsersFormComponent},
                    {path: 'internal-users-form/:Tr_Id/:mode', component:InternalUsersFormComponent},
                ]
            },
            {
                path: 'Reports', component: ReportsComponent,
                children: [{path: '', component: TodaysTicketsComponent},
                {path: 'all_closed_tickets', component: AllClosedTicketsComponent},
                {path: 'all_opened_tickets', component: AllOpenedTicketsComponent},
                {path: 'all_unassigned_tickets', component: AllUnassignedTicketsComponent},
                {path: 'client_highest_tickets', component: ClientHighestTicketsComponent},
                {path: 'client_lowest_tickets', component: ClientLowestTicketsComponent},
                {path: 'clientopennclosed_ticketCount', component: ClientOpenNclosedTicketCountComponent},
                {path: 'clients_count_for_projects', component: ClientsCountForProjectsComponent},
                {path: 'expecteddatewise_allticketcount', component: ExpectedDatewiseAllTicketCountComponent},
                {path: 'overdue_reports', component: OverdueReportsComponent},
                {path: 'priority_issue', component: PriorityIssueComponent},
                {path: 'projectwise_client_list', component: ProjectwiseClientListComponent},
                {path: 'todays_closed_tickets', component: TodaysClosedTicketsComponent},
                {path: 'todays_open_unresolved_tickets', component: TodaysOpenUnresolvedTicketsComponent},
                {path: 'todays_opened_tickets', component: TodaysOpenedTicketsComponent},
                {path: 'todays_unassigned_tickets', component: TodaysUnassignedTicketsComponent},
                {path: 'employeewise-closed-tickets', component: EmployeewiseClosedTicketsComponent},
                {path: 'employeewise-pending-tickets', component: EmployeewisePendingTicketsComponent},
                {path:'overall-report', component: OverallreportComponent}
            ]  
            },

            
            // {
            //     path: 'clients',component: MastersComponent,
            //     children: [
            //         {path: '', component:ClientGridComponent},
            //         {path: 'client-form', component:ClientFromComponent},]
            // },

            

            // {
            //     path: 'regionform',component: MastersComponent,
            //     children: [{path: '', component: PetitionApprovalComponent}]
            // },        
            
        ]
    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{path: '', component: LoginComponent}]
    },
            
    {
        path: 'signup', component: RegistrationComponent,
        children: [{path: '', component: SignupComponent}]  
    },

    

    // {
    //     path: 'forgot-password', component: RegistrationComponent,
    //     children: [{path: '', component: ForgotPasswordComponent}]  
    // },
    
    
    { path : '', redirectTo:'/login', pathMatch : 'full'}
];


// WEBPACK FOOTER //
// ./src/route.ts